import { apiGet, apiPost, apiPatch } from "../client";
import type { UserApiResponse } from "../types";
import type { UserDto } from "../types";

export interface LoginInput {
  username: string;
  password: string;
}

export interface UserCreateInput {
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  password: string;
  role: string;
}

export interface UserUpdateInput {
  username?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  password?: string;
  role?: string;
}

export async function login(data: LoginInput) {
  return apiPost<UserApiResponse<UserDto>>("/user/login", data);
}

export async function getCurrentUser(userId: string) {
  return apiGet<UserApiResponse<UserDto>>(`/user/get-user/${userId}`);
}

export async function getAllUsers() {
  return apiGet<UserApiResponse<UserDto[]>>("/User/all-users");
}

export async function createUser(data: UserCreateInput) {
  return apiPost<UserApiResponse<UserDto>>("/User/create-user", data);
}

export async function updateUser(userId: string, data: UserUpdateInput) {
  return apiPatch<UserApiResponse<UserDto>>(`/User/update-user/${userId}`, data);
}
